const MODULE_DATA = {
  offers: {
    badge: 'Módulo 01 • Ofertas Laborales & Cartas Oferta',
    title: 'Generador de Ofertas Económicas por Fórmulas',
    desc: 'Crea, calcula y administra cartas oferta laborales (internas y externas). Configura automáticamente el sueldo base, prestaciones adicionales, beneficios extra y retenciones de impuestos mediante fórmulas personalizadas.',
    features: [
      'Generación de Folios Únicos por Oferta (Ej. 20260719_000003)',
      'Comparativa automática de Empleo Actual vs Empleo Ofertado',
      'Desglose dinámico de Aguinaldo, Vales de Despensa, Fondo de Ahorro y Bonos',
      'Matriz de Firmas Electrónicas de Autorización para activación de oferta'
    ],
    tableHead: ['Folio', 'Nombre', 'Tipo Oferta', 'Estado Oferta', 'Firmas'],
    tableRows: [
      ['20260719_000003', 'Mario Dias Garcia', 'Externa', 'Nueva', '<span class="status-chip chip-pending">Sin firmas registradas</span>'],
      ['20260528_000002', 'Mateo Dias Lopez', 'Interna', 'Nueva', '<span class="status-chip chip-pending">Sin firmas registradas</span>'],
      ['20260527_000001', 'Alejandro Lopez Luna', 'Externa', 'Firmas', '<span class="status-chip chip-success">✓ Firmado (3/3)</span>']
    ]
  },
  employees: {
    badge: 'Módulo 02 • Administración de Empleados',
    title: 'Lista de Empleados y Carga Masiva',
    desc: 'Centraliza el expediente laboral de toda tu plantilla. Permite la importación masiva de empleados a través de plantillas y su asignación inmediata a Áreas, Divisiones y Posiciones.',
    features: [
      'Búsqueda avanzada por Folio, Nombre, Área, División y Estatus Activo',
      'Carga masiva de colaboradores y actualización de expedientes',
      'Ficha técnica detallada por empleado con historial salarial',
      'Asignación directa a catálogos organizacionales'
    ],
    tableHead: ['ID Empleado', 'Nombre Colaborador', 'Área', 'División', 'Estatus'],
    tableRows: [
      ['Empleado #13323', 'Mateo Dias Lopez', 'Área Cuatro', 'División Cinco', '<span class="status-chip chip-success">Activo</span>'],
      ['Empleado #13326', 'Dario Navarro Calderon', 'Dirección General', 'Corporativo', '<span class="status-chip chip-success">Activo</span>'],
      ['Empleado #13327', 'Carmelo Audevez Hernandez', 'Desarrollo', 'Tecnología', '<span class="status-chip chip-success">Activo</span>']
    ]
  },
  organigram: {
    badge: 'Módulo 03 • Estructura Organizacional',
    title: 'Generador de Organigrama Jerárquico',
    desc: 'Visualiza la estructura jerárquica de tu empresa en un diagrama de árbol dinámico e interactivo. Identifica líderes de equipo, dependencias de puestos y exporta o imprime con un clic.',
    features: [
      'Generación automática en tiempo real basada en las relaciones de puestos',
      'Nodos visuales con número de empleado, nombre, puesto y reporte directo',
      'Botones de Exportación instantánea y formato listo para Impresión',
      'Sincronización automática ante cambios en la estructura de personal'
    ],
    tableHead: ['Nivel Jerárquico', 'Líder / Superior', 'Reportes Directos', 'Acciones'],
    tableRows: [
      ['Dirección General', 'Mateo Dias Lopez (#13323)', 'SubDirector Dario Navarro (#13326)', '<span class="status-chip chip-success">Ver Organigrama</span>'],
      ['SubDirección C', 'Dario Navarro (#13326)', '7 Empleados en Árbol', '<span class="status-chip chip-success">Ver Organigrama</span>'],
      ['Área Operativa', 'Carmelo Audevez (#13327)', 'Equipo de Desarrollo', '<span class="status-chip chip-success">Ver Organigrama</span>']
    ]
  },
  budget: {
    badge: 'Módulo 04 • Análisis Financiero RH',
    title: 'Cálculo de Presupuesto por Empleado',
    desc: 'Calcula con precisión el costo total por empleado proyectado en base a fórmulas configurables de salarios, beneficios extra y retenciones fiscales obligatorias.',
    features: [
      'Motor de fórmulas matemáticas configurables por el administrador',
      'Proyección de Costos por Empleado agrupados por división y área',
      'Cálculo automático de retenciones de impuestos y cuotas',
      'Simulador de presupuestos antes de autorizar nuevas contrataciones'
    ],
    tableHead: ['Puesto / Empleado', 'Sueldo Base', 'Total Beneficios', 'Retenciones', 'Costo Total'],
    tableRows: [
      ['SubDirector C', '$45,000.00', '$12,450.00', '$8,900.00', '<span class="status-chip chip-success">$48,550.00 MXN</span>'],
      ['Líder de Proyecto', '$32,000.00', '$8,200.00', '$6,100.00', '<span class="status-chip chip-success">$34,100.00 MXN</span>'],
      ['Especialista de Área', '$22,000.00', '$5,400.00', '$3,900.00', '<span class="status-chip chip-success">$23,500.00 MXN</span>']
    ]
  },
  catalogs: {
    badge: 'Módulo 05 • Parametrización del Sistema',
    title: 'Catálogos y Grupos de Configuración',
    desc: 'Gestiona la infraestructura de datos de tu empresa: Áreas, Divisiones, Posiciones, Objetos de Catálogo, Beneficios, Retenciones y Grupos de Fórmulas.',
    features: [
      'Catálogos editables de Áreas, Posiciones y Divisiones Empresariales',
      'Catálogo de Beneficios (Aguinaldo, Fondo de Ahorro, Vales, Bonos)',
      'Catálogo de Retenciones de impuestos e importe de deducciones',
      'Grupos de Fórmulas y Grupos de Vacaciones parametrizables'
    ],
    tableHead: ['Catálogo', 'Elementos Registrados', 'Tipo de Configuración', 'Estado'],
    tableRows: [
      ['Catálogo de Beneficios', '10 Tipos de Prestación', 'Sueldo + Prestaciones / Bonos', '<span class="status-chip chip-success">Configurado</span>'],
      ['Grupos de Fórmulas', 'Fórmulas Activas', 'Cálculo de Sueldo y Retenciones', '<span class="status-chip chip-success">Configurado</span>'],
      ['Catálogo de Posiciones', 'Estructura por Puestos', 'Niveles Organigrama', '<span class="status-chip chip-success">Configurado</span>']
    ]
  },
  signatures: {
    badge: 'Módulo 06 • Flujos de Aprobación',
    title: 'Firmas Electrónicas y Autorizaciones',
    desc: 'Implementa matrices de firmas de autorización para contratos y cartas oferta. Rastrea electrónicamente el estatus de aprobación de administradores en tiempo real.',
    features: [
      'Asignación de Grupos de Firmas obligatorios por tipo de oferta',
      'Indicadores visuales de estado: Verificado (Verde), Pendiente (Naranja) y Usuario (Azul)',
      'Firmas electrónicas de validación para activación inmediata de contratos',
      'Bitácora inmutable de autorizaciones con hora y usuario firmante'
    ],
    tableHead: ['Folio Oferta', 'Solicitante', 'Matriz de Firmas', 'Estatus Final'],
    tableRows: [
      ['20260527_000001', 'Alejandro Dias', '✓ Admin • 🕒 Finanzas • 👤 RH', '<span class="status-chip chip-pending">Firmas en proceso</span>'],
      ['20260520_000088', 'Valeria Morales', '✓ Admin • ✓ Finanzas • ✓ RH', '<span class="status-chip chip-success">Autorizada</span>'],
      ['20260515_000074', 'Fernando Torres', '✓ Admin • ✓ Finanzas • ✓ RH', '<span class="status-chip chip-success">Autorizada</span>']
    ]
  }
};

export function initModulesSwitcher() {
  const tabs = document.querySelectorAll('.modules-tabs-nav .tab-btn');
  const badgeEl = document.querySelector('#module-pane-badge');
  const titleEl = document.querySelector('#module-pane-title');
  const descEl = document.querySelector('#module-pane-desc');
  const listEl = document.querySelector('#module-pane-list');
  const tableHeadEl = document.querySelector('#module-mock-thead');
  const tableBodyEl = document.querySelector('#module-mock-tbody');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const key = tab.getAttribute('data-module');
      if (!key || !MODULE_DATA[key]) return;

      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      const data = MODULE_DATA[key];

      if (badgeEl) badgeEl.textContent = data.badge;
      if (titleEl) titleEl.textContent = data.title;
      if (descEl) descEl.textContent = data.desc;

      if (listEl) {
        listEl.innerHTML = data.features
          .map(f => `<li><span class="check-icon">✓</span> ${f}</li>`)
          .join('');
      }

      if (tableHeadEl) {
        tableHeadEl.innerHTML = `<tr>${data.tableHead.map(h => `<th>${h}</th>`).join('')}</tr>`;
      }

      if (tableBodyEl) {
        tableBodyEl.innerHTML = data.tableRows
          .map(row => `<tr>${row.map(cell => `<td>${cell}</td>`).join('')}</tr>`)
          .join('');
      }
    });
  });
}
